import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Panel } from "@/components/KpiCard";
import { api, errMsg } from "@/lib/api";

export const ComptablePanel = () => {
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/comptable").then((r) => setC(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/comptable", c); setC(data); toast.success("Coordonnées du comptable enregistrées"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!c) return null;
  return (
    <Panel title="Comptable (envoi par courriel)" testId="comptable-panel"
      action={<Button size="sm" onClick={save} disabled={busy || !c.email} className="bg-emerald-700 hover:bg-emerald-800" data-testid="comptable-save-button">
        {busy ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-1" />}Enregistrer</Button>}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="space-y-1"><Label htmlFor="cpt-email">Courriel du comptable</Label>
          <Input id="cpt-email" type="email" value={c.email} onChange={(e) => setC({ ...c, email: e.target.value })} placeholder="comptable@exemple.com" data-testid="comptable-email-input" /></div>
        <div className="space-y-1"><Label htmlFor="cpt-nom">Nom du comptable</Label>
          <Input id="cpt-nom" value={c.nom} onChange={(e) => setC({ ...c, nom: e.target.value })} data-testid="comptable-nom-input" /></div>
        <div className="space-y-1 md:col-span-2"><Label htmlFor="cpt-msg">Message d'accompagnement par défaut</Label>
          <Textarea id="cpt-msg" rows={5} value={c.message} onChange={(e) => setC({ ...c, message: e.target.value })} data-testid="comptable-message-input" /></div>
      </div>
      <p className="mt-3 text-xs text-slate-500">Le message reste modifiable avant chaque envoi. Les réponses du comptable arrivent à votre adresse.</p>
    </Panel>
  );
};
